import { render, staticRenderFns } from "./PradaAreasRecompRegTable.vue?vue&type=template&id=0f966d78&lang=pug"
import script from "./PradaAreasRecompRegTable.vue?vue&type=script&lang=js"
export * from "./PradaAreasRecompRegTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports